export default class {
	constructor(selector) {
		this.element = selector;
		this.handlers = {
			show: [],
			close: [],
		};
		this.initObserver();
	}

	initObserver() {
		const config = {
			attributes: true,
			attributeOldValue: true,
			childList: true,
		};
		const isClassAdded = (mutation) => {
			if ((mutation.type !== 'attributes') || (mutation.attributeName !== 'class')) {
				return false;
			}
			const exists = this.element.className.includes('et_bloom_animated');
			const existed = mutation.oldValue.includes('et_bloom_animated');
			return exists && !existed;
		};
		const isClassRemoved = (mutation) => {
			if ((mutation.type !== 'attributes') || (mutation.attributeName !== 'class')) {
				return false;
			}
			const exists = this.element.className.includes('et_bloom_exit_animation');
			const existed = mutation.oldValue.includes('et_bloom_animated');
			return exists && existed;
		};

		const callback = (mutationsList) => {
			if (!document.body.contains(this.element)) {
				this.destroy();
			}
			for (let i = 0; i < mutationsList.length; i++) {
				const mutation = mutationsList[i];
				if (isClassAdded(mutation)) {
					this.emit('show');
				}
				if (isClassRemoved(mutation)) {
					this.emit('close');
				}
			}
		};
		this.observer = new MutationObserver(callback);
		this.observer.observe(this.element, config);
	}

	destroy() {
		this.observer.disconnect();
		this.emit('close');
	}

	onShow(handler) {
		this.handlers.show.push(handler);
	}

	onClose(handler) {
		this.handlers.close.push(handler);
	}

	emit(event) {
		this.handlers[event].forEach((item) => {
			item.call(this, event);
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/bloom/observer.js